import React from "react";
import Overlay from "../Overlay";
import Select from "react-select";
import moment from "moment";
import {getDateOrNull, getSelectLabels, getNameFromID, showModalNoOutsideClick} from "../../util/FormatUtil";
import TestType from "../../types/TestType";
import {sweetalert} from "../../App";
import DatePicker from 'react-datepicker'
import SystemAPI from "../../network/SystemAPI";
import {CustomFieldType} from "../../types/CustomFieldType";
import TestsAPI from "../../network/TestsAPI";
import Validator, {ValidationEntry} from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import AdminAPI from "../../network/AdminAPI";
import {AdminPages} from "./AdminNav";
import ServicesAPI from "../../network/ServicesAPI";
import { isEmptyObject } from "jquery";
import { ServiceFormModal } from "../modals/ServiceFormModal";
import { PatientInfoModal } from "../modals/PatientInfoModal";
import { InsuranceModal } from "../modals/InsuranceModal";
import WalkinAPI from "../../network/WalkinAPI";
import { ImportantInformationModal } from "../modals/ImportantInformationModal";
import Parser from "html-react-parser";
import { ROIModal } from "../modals/ROIModal";
import InformedConsentModal from "../modals/InformedConsentModal";
import { CustomerAPI } from "../../network/CustomerAPI";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import PatientAPI from "../../network/PatientAPI";


interface WalkinFormState{
    showLoading:boolean
    patientInformation
    facilityID?
    Memo?
    SpecimenID?
    facilities?
    tests:TestType[]
    Lot?
    selectedTests:{value, label}[] | any
    collectionDate?
    testOrderedDate?
    isSubmitting
    validSpecimenSources?
    allCustomQuestions:CustomFieldType[]
    sources?
    services
    selectedServices    
    serviceLabels
    insuranceInformation
    showInsurance:boolean
    associatedTests:TestType[]
    imageSaved:boolean
    selectedServiceID?:number
    serviceSpecificCustomQuestions?
    savedServices?
    savedPatientInformation?
    savedInsuranceInformation?
    servicesObjectsArray?
    states?
    race?
    gender?
    ethnicity?
    countries?
    savedImportantInformation
    acknowledged
    consentEntities: {
        ID: number;
        Name: string;
        FacilityID: number;
        AccessCode: string;
      }[];
    declineConsent:boolean;
    roiObjectsArray?;
    savedROIServices?;
    legalName?
    portalPatients?
}

interface WalkinFormProps{}
export default class WalkinForm extends React.Component<WalkinFormProps, WalkinFormState>{
    private roiRef: any;
    private patientInfoRef: any;
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            serviceLabels: [],
            selectedServices: [],
            selectedTests: [],
            patientInformation:{},
            collectionDate:new Date(),
            testOrderedDate:new Date(),
            validSpecimenSources:[],
            sources: [],
            showLoading:false,
            isSubmitting: false,
            tests:[],
            allCustomQuestions: [],
            insuranceInformation:{},
            showInsurance: false,
            associatedTests: [],
            imageSaved: false,
            facilityID: null,
            savedServices: [],
            states:[],
            gender:[],
            ethnicity:[],
            race:[],
            countries:[],
            servicesObjectsArray: [],
            savedImportantInformation:false,
            acknowledged: false,
            consentEntities: [],
            declineConsent:false,
            roiObjectsArray: [],
            savedROIServices: [],
            portalPatients: []
        };
        this.submit = this.submit.bind(this);
        this.assignClearInsurance = this.assignClearInsurance.bind(this);
        this.assignClearService = this.assignClearService.bind(this);
        this.roiRef = React.createRef();
        this.patientInfoRef = React.createRef();
    }

    componentDidMount() {
        this.setState({showLoading: true}, () => {
            CustomerAPI.getPolicyName().then((data) => {
                this.setState({ legalName: data.name });
              });
            TestsAPI.getValidSpecimenSources().then(data => {
                this.setState({validSpecimenSources: data})
            })
            AdminAPI.getFacilitiesWithAddress().then(async data => {
                this.setState({ facilities: data as { label: string; value: number }[] })
            })
            PatientAPI.getPatientsFromPatientPortal().then(async data => {
                this.setState({portalPatients: data.patients})
            })
            TestsAPI.getAllTestDetails().then(data => {
                let enabledTests = data.tests.filter(t => t.IsEnabled)
                this.setState({tests: enabledTests, showLoading: false})
            });

            AdminAPI.getFacilitiesWithAddress(true).then(data => {
                this.setState({facilities: data})
            })

            SystemAPI.getCustomQuestions(AdminPages.WalkinForm,).then(res =>{
                this.setState({allCustomQuestions:res.questions.sort((a,b) => a.Order - b.Order)})
            })
            SystemAPI.getAllStates().then(data => {
                this.setState({states: data})
            })
            SystemAPI.getAllRaces().then(data => {
                this.setState({race: data})
            })
            SystemAPI.getAllGenders().then(data => {
                this.setState({gender: data})
            })
            SystemAPI.getAllEthnicities().then(data => {
                this.setState({ethnicity: data})
            })
            SystemAPI.getAllCountries().then(data => {
                this.setState({countries: data})
            })
            ServicesAPI.getServicesForWalkinForm().then(response => {
                let servicesWithDTCRemoved = response.data.filter(f => !f.IsDTC)
                this.setState({services: servicesWithDTCRemoved, serviceLabels: getSelectLabels(servicesWithDTCRemoved),showLoading: false});
            });
            SystemAPI.getConsentEntities().then((data) => {
                this.setState({ consentEntities: data });
              });
        })           

    }

    submit(){


        if (!this.state.savedImportantInformation) {
            return sweetalert.fire({
              icon: "error",
              title: "",
              text: "Important Information must be reviewed.",
            });
        }

        let insuranceInfo = {}
        let insuranceCards = []

        let formValidation = {
            FacilityID: this.state.facilityID,
            TestOrderedDate: this.state.testOrderedDate,
            CollectionDate: this.state.collectionDate,
        }

        let validator = new Validator<any>()
            .withSimpleValidation("FacilityID", Validators.requireNonNullValidator("Facility"))
            .withComposedValidation("CollectionDate", new ValidationEntry(Validators.requireNotFutureDate("Collection Date")), new ValidationEntry(Validators.requireNonNullValidator("Collection Date")))
            .withComposedValidation("TestOrderedDate", new ValidationEntry(Validators.requireNotFutureDate("Test Ordered Date")), new ValidationEntry(Validators.requireNonNullValidator("Test Ordered Date")))
        let validationResponse = validator.validate(formValidation);
        if(!validationResponse.success) {
            return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
        }



        //set up patientInfo   
        let patientInfo;
        if(isEmptyObject(this.state.patientInformation)){
            return sweetalert.fire({icon: 'error', title: '', text: "Patient Information cannot be blank"});
        }
        else{
            patientInfo = JSON.parse(JSON.stringify(this.state.patientInformation));
        }     
        
        delete patientInfo['confirmEmail'];
        patientInfo.FacilityID = this.state.facilityID ? this.state.facilityID.value : null;
        delete patientInfo['errors']
        patientInfo.CollectionDate = getDateOrNull(this.state.collectionDate);
        patientInfo.TestOrderedDate = getDateOrNull(this.state.testOrderedDate);
        patientInfo.PatientCountry = patientInfo.PatientCountry ? patientInfo.PatientCountry : 'United States';
        patientInfo.PatientCounty = patientInfo.PatientCounty ? patientInfo.PatientCounty.trim() : null;
        patientInfo.PatientMiddleName = patientInfo.PatientMiddleName ? patientInfo.PatientMiddleName.trim() : null; 
        patientInfo.GuardianFirstName = patientInfo.GuardianFirstName.trim().length > 0 ? patientInfo.GuardianFirstName.trim() : null;       
        patientInfo.GuardianLastName = patientInfo.GuardianLastName.trim().length > 0 ? patientInfo.GuardianLastName.trim() : null;       
        
        //set insuranceCards if provided
        if(!isEmptyObject(this.state.insuranceInformation)){
            insuranceInfo = JSON.parse(JSON.stringify(this.state.insuranceInformation))
            insuranceCards = [this.state.insuranceInformation.FrontCardImgFile, this.state.insuranceInformation.BackCardImgFile]
            delete insuranceInfo['FrontCardImgFile']
            delete insuranceInfo['BackCardImgFile']
            delete insuranceInfo['errors']
        }

        //check Service Information
        if(!this.state.servicesObjectsArray || this.state.servicesObjectsArray.length < 1){
            return sweetalert.fire({icon: 'error', title: '', text: `Sample Information must be complete`})
        }

        if(this.state.servicesObjectsArray.length !== this.state.selectedServices.length){
            return sweetalert.fire({icon: 'error', title: '', text: `All Sample Information must be complete`})
        }
        if(this.state.servicesObjectsArray && this.state.servicesObjectsArray?.length > 0){
            for (let i = 0; i < this.state.servicesObjectsArray.length; i++) {
                const element = this.state.servicesObjectsArray[i];
                if(!element.sampleInfo.specimenID || element.sampleInfo.specimenID.length < 8){
                    return sweetalert.fire({icon: 'error', title: '', text: `Specimen ID must be at least 8 characters for ${getNameFromID(element.serviceID, this.state.services)}.`})
                }
                if(element.sampleInfo.selectedTests.length < 1){
                    return sweetalert.fire({icon: 'error', title: '', text: `Sample Information must be completed for ${getNameFromID(element.serviceID, this.state.services)}`})
                }
                if(element.sampleInfo.isLabService){
                    if(isBlank(element.sampleInfo.specimenID) || isOnlyWhitespace(element.sampleInfo.specimenID)){
                        return sweetalert.fire({icon: "error", title: "", text: `Specimen ID is blank for ${getNameFromID(element.serviceID, this.state.services)}`});
                    }
                }
                if(!element.sampleInfo.specimenSourceID){
                    return sweetalert.fire({icon: 'error', title: '', text: `Specimen Source must be selected`})
                }
            }
        }

    
        if (!this.state.acknowledged) {
            return sweetalert.fire({
              icon: "error",
              title: "",
              text: "Summary acknowledgment box must be checked.",
            });
        }

        if(this.state.servicesObjectsArray.length < 1 || this.state.servicesObjectsArray.length !== this.state.selectedServices.length){
            return sweetalert.fire({icon: 'error', title: '', text: "Service Information cannot be blank"});
        }

        //check for duplicate specimenIDs
        if(this.state.servicesObjectsArray.length > 1 ){
            let specimenIDs = []
             this.state.servicesObjectsArray.map(s => {
                specimenIDs.push(s.sampleInfo.specimenID)
            })
            let duplicates = specimenIDs.filter((item, index) => specimenIDs.indexOf(item) !== index)
            if(duplicates.length > 0){
                return sweetalert.fire({icon: 'error', title: '', text: "Specimen IDs must be unique"});
            }
        }

        let serviceObjectArrayCopy = JSON.parse(JSON.stringify(this.state.servicesObjectsArray))  
        
        let roiObjectsArray = JSON.parse(
            JSON.stringify(this.state.roiObjectsArray)
          );


        this.setState({showLoading:true, isSubmitting: true}, async ()=>{
            try {
                let result = await WalkinAPI.walkinForm(patientInfo, insuranceInfo, serviceObjectArrayCopy, roiObjectsArray, insuranceCards)
                if(result.success){
                    sweetalert.fire({icon: 'success', title: '', text: "Form submitted successfully"});
                    const frontUpload = document.querySelector('#FrontCardCapture') as any;
                    frontUpload.value = '';
                    const backUpload = document.querySelector('#BackCardCapture') as any;
                    backUpload.value = '';
                    let ackCheckbox = document.getElementById("acknowledge") as any;
                    ackCheckbox.checked = false

                    this.setState({
                        isSubmitting: false, 
                        imageSaved:false, 
                        savedPatientInformation: false, 
                        patientInformation: {},
                        insuranceInformation: {},
                        servicesObjectsArray: [],
                        savedInsuranceInformation: false, 
                        savedServices: [],
                        collectionDate: new Date(),
                        testOrderedDate: new Date(),
                        savedImportantInformation: false,
                        savedROIServices: [],
                        acknowledged: false,
                        roiObjectsArray: [],
                        declineConsent: false
                    }, () =>{
                        this.clearInsuranceForm(); 
                        this.roiRef.current.clearState()
                        this.patientInfoRef.current.clearForWalkin()
                    }); 
                }else{
                    sweetalert.fire({icon: 'error', title: '', text: result.reason});
                }
                this.setState({showLoading: false, isSubmitting: false})
            }
            catch (e) {
                console.error(e);
                sweetalert.fire({icon: 'error', title: '', text: "Failed to submit"});
                this.setState({showLoading: false, isSubmitting: false})
            }
        })
    }

    clear(){
        const frontUpload = document.querySelector('#FrontCardCapture') as any;
        frontUpload.value = '';
        const backUpload = document.querySelector('#BackCardCapture') as any;
        backUpload.value = '';
        let ackCheckbox = document.getElementById("acknowledge") as any;
        ackCheckbox.checked = false
        this.setState({
            isSubmitting: false, 
            imageSaved:false, 
            savedPatientInformation: false, 
            patientInformation: {},
            insuranceInformation: {},
            showInsurance: false,
            facilityID: null,
            servicesObjectsArray: [],
            savedInsuranceInformation: false, 
            savedServices: [],
            selectedServices: [],
            collectionDate: new Date(),
            testOrderedDate: new Date(),
            savedImportantInformation: false,
            savedROIServices: [],
            acknowledged: false,
            roiObjectsArray: [],
            declineConsent: false
        }, () =>{
            this.clearInsuranceForm(); 
            this.roiRef.current.clearState()
            this.patientInfoRef.current.clearForWalkin()
        }); 
    }

    clearServiceForm = null;

    assignClearService(func){
        this.clearServiceForm = func;
    }

    clearInsuranceForm = null;

    assignClearInsurance(func){
        this.clearInsuranceForm = func;
    }


    handleDateOnChange(value, state){
        if (value) {
            this.setState({[state]: value } as any);
        }
        else{
            this.setState({[state]: null} as any)
        }
    }

    handleServiceChange(event){
        let tempServices = []
        let tempTestIDs = []
        let tempCustomQuestions = []
        let showInsurance = false

        if(event && event.length > 0 && this.state.services && this.state.services.length > 0){
            event.map(e => {

                for(let i = 0; i < this.state.services.length; i++){
                    if(e.value === this.state.services[i].ID){

                        //selectedServices
                        tempServices.push(this.state.services[i])

                        //assciated tests
                        if(this.state.services[i].Tests && this.state.services[i].Tests.length > 0){
                            tempTestIDs = tempTestIDs.concat(this.state.services[i].Tests)
                        }

                        break
                    }
                }

                //customQuestions
                if(this.state.allCustomQuestions && this.state.allCustomQuestions.length > 0){
                    tempCustomQuestions.push(this.state.allCustomQuestions.filter(q => q.ServiceID === e.value && q.Options.isActive))
                }

            })
        }

        tempTestIDs = Array.from(new Set(tempTestIDs))
        let associatedTests = []
        if(tempTestIDs && tempTestIDs.length > 0 && this.state.tests && this.state.tests.length > 0){
            tempTestIDs.map(tt => {
                for(let i = 0; i < this.state.tests.length; i++){
                    if(tt === this.state.tests[i].ID){
                        associatedTests.push(this.state.tests[i])
                        break
                    }
                }
            })
            
        }

        showInsurance = !!tempServices.find(s => s.ShowInsurance)

        this.setState({selectedServices: tempServices, associatedTests: associatedTests, showInsurance: showInsurance, selectedTests: [], savedImportantInformation: false})

    }

    handleSaveServiceSpecificInfo(e){
        let serviceID = e.sampleInfo.serviceID ? e.sampleInfo.serviceID : null
        let savedServices = this.state.savedServices
        let servicesObjectsArray = this.state.servicesObjectsArray
        let showInsurance = this.state.services.find(s => s.ID === serviceID).ShowInsurance;

        if(serviceID){
            savedServices.push(serviceID)
        }

        if(servicesObjectsArray?.length > 0){
            servicesObjectsArray.map((r, i) => {
                if(r.serviceID === serviceID){
                    servicesObjectsArray.splice(i, 1)
                }
            })
        }
        servicesObjectsArray.push({
            serviceID: serviceID,
            submittedAnswers: e.answeredCustomQuestions,
            sampleInfo: {
                showInsurance: showInsurance,
                isLabService: e.sampleInfo.isLabService ? e.sampleInfo.isLabService : false,
                memo: e.sampleInfo.memo ? e.sampleInfo.memo : null,
                selectedTests: e.sampleInfo.selectedTests?.length > 0 ? e.sampleInfo.selectedTests : [],
                serviceID: e.sampleInfo.serviceID ? e.sampleInfo.serviceID : null,
                specimenSourceID: e.sampleInfo.specimenSourceID ? e.sampleInfo.specimenSourceID : null,
                specimenID: e.sampleInfo.specimenID ? e.sampleInfo.specimenID : null,
                lot: e.sampleInfo.lot ? e.sampleInfo.lot : null
            }
        })

        this.setState({
            savedServices: savedServices, 
            servicesObjectsArray: servicesObjectsArray
        })
    }

    handleRelease(releaseObj) {
        let serviceID = releaseObj.serviceID ? releaseObj.serviceID : null;
        let savedROIServices = this.state.savedROIServices;
        let roiObjectsArray = this.state.roiObjectsArray;
    
        if (serviceID) {
          if (savedROIServices?.length > 0) {
            savedROIServices.map((r, i) => {
              if (r === serviceID) {
                savedROIServices.splice(i, 1);
              }
            });
          }
          savedROIServices.push(serviceID);
        }
    
        if (roiObjectsArray?.length > 0) {
          roiObjectsArray.map((r, i) => {
            if (r.serviceID === serviceID) {
              roiObjectsArray.splice(i, 1);
            }
          });
        }
    
        roiObjectsArray.push({
          serviceID: serviceID,
          entityID: releaseObj.entityID,
        });
    
        this.setState({
          savedROIServices: savedROIServices,
          roiObjectsArray: roiObjectsArray,
        });
      }
    
      handleRemoveRelease(releaseObj) {
    
        if(releaseObj === 'all'){
          this.setState({
            savedROIServices: [],
            roiObjectsArray: [],
          });
          return; 
        }
    
    
        let serviceID = releaseObj.serviceID ? releaseObj.serviceID : null;
        let savedROIServices = this.state.savedROIServices;
        let roiObjectsArray = this.state.roiObjectsArray;
    
        if (serviceID) {
          const index = savedROIServices.indexOf(serviceID);
          if (index > -1) {
            savedROIServices.splice(index, 1);
          }
        }
    
        if (roiObjectsArray?.length > 0) {
          roiObjectsArray.map((r, i) => {
            if (r.serviceID === serviceID) {
              roiObjectsArray.splice(i, 1);
            }
          });
        }

    
        this.setState({
          savedROIServices: savedROIServices,
          roiObjectsArray: roiObjectsArray,
        });
      }
    

    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        
        // console.log('walkin props', this.props)
        // console.log('walkin state', this.state)

        return (
            <React.Fragment>
                <Overlay show_loading={this.state.showLoading}/>

                <ImportantInformationModal
                    services={this.state.services}
                    selectedServices={this.state.selectedServices}
                    setAccepted={() => this.setState({ savedImportantInformation: true })}
                />

                <ServiceFormModal 
                    submit={(e) => this.handleSaveServiceSpecificInfo(e)} 
                    service={this.state.services.find(f => f.ID === this.state.selectedServiceID)} 
                    reviewInfo={this.state.servicesObjectsArray?.length > 0 && this.state.servicesObjectsArray.find(f => f.serviceID === this.state.selectedServiceID)} 
                    attachClearStateFunc={this.assignClearService} 
                    customQuestions={this.state.serviceSpecificCustomQuestions} 
                    associatedTests={this.state.associatedTests} 
                    sources={this.state.validSpecimenSources} 
                    showSampleInfo={true}
                    tests={this.state.tests}
                />

                <PatientInfoModal 
                    ref={this.patientInfoRef}
                    fromWalkin={true}
                    submit={(e) => {
                        this.setState({patientInformation: e.patientInfo, savedPatientInformation: true})
                    }}
                    states={this.state.states}
                    gender={this.state.gender}
                    ethnicity={this.state.ethnicity}
                    race={this.state.race}
                    countries={this.state.countries}
                    portalPatients={this.state.portalPatients}
                />

                <InsuranceModal 
                    submit={(e) => this.setState({insuranceInformation: e, savedInsuranceInformation: true})}
                    attachClearStateFunc={this.assignClearInsurance}
                    imageSaved={this.state.imageSaved}
                    handleImageSaved={(e) => this.setState({imageSaved:e})}
                    states={this.state.states}
                />

                <ROIModal
                    ref={this.roiRef}
                    releaseChanged={(r) => this.handleRelease(r)}
                    selectedServices={this.state.selectedServices}
                    services={this.state.services}
                    consentEntities={this.state.consentEntities}
                    handleRemove={(e) => this.handleRemoveRelease(e)}
                    handleRemoveAll={() => this.setState({declineConsent: true}, ()=> this.handleRemoveRelease('all'))}
                    reviewInfo={
                        this.state.roiObjectsArray?.length > 0 &&
                        this.state.roiObjectsArray.find(
                        (f) => f.serviceID === this.state.selectedServiceID
                        )
                    }
                />

                <InformedConsentModal
                    legalName={this.state.legalName}
                    selectedServices={this.state.selectedServices}
                />

                <div className="container-fluid  min-vh-100 ">
                    <div className={"row"}>
                        <div className=" col-12 col-sm-12  col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 pt-2">
                            <div className="card mt-2">
                                <div className="card-header verlag-bold">
                                    <h4>Service Selection</h4>
                                </div>
                                <div className="card-body">
                                    <div className="form-group row">
                                        <label  className="col-sm-4 col-form-label" style={{fontWeight: 'bold'}}>Service</label>
                                        <div className="col-sm-8  p-0 m-0">
                                            <Select
                                                isMulti={true}
                                                isSearchable={ true}
                                                placeholder={"Please Select..."}
                                                noOptionsMessage={()=>  "No option"}
                                                className={"state_select"}
                                                options={this.state.serviceLabels}
                                                onChange={(e) => this.handleServiceChange(e)}
                                                value={this.state.selectedServices.map(s => ({label:s.Name, value:s.ID}))}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor={'Facility'} className="col-sm-4 col-form-label" style={{fontWeight: 'bold'}}>Facility</label>
                                        <div className="col-sm-8  p-0 m-0" id={'Facility'}>
                                            <Select
                                                isSearchable={ true}
                                                placeholder={"Please Select..."}
                                                noOptionsMessage={()=>  "No option"}
                                                className={"state_select"}
                                                options={this.state.facilities}
                                                onChange={(e) => this.setState({facilityID:e})}
                                                value={this.state.facilityID}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className={"col-12 col-md-4 pl-3 pl-md-3"}>
                                            <label htmlFor={'Collection Date'} style={{fontWeight: 'bold', paddingTop: '0.5em'}}>Collection Date</label>
                                        </div>
                                        <div className={"d-none d-md-block col-md-8 pl-md-0"} id={'Collection Date'}>
                                            <DatePicker
                                                placeholderText="--/--/---- --:-- --"
                                                minDate={new Date('01-01-1000')}
                                                maxDate={new Date('12-31-9999')}
                                                showTimeSelect
                                                selected={this.state.collectionDate ? Date.parse(moment(this.state.collectionDate, 'MM-DD-YYYY h:mm aa').toISOString()) : null}
                                                dateFormat="MM/dd/yyyy h:mm aa"
                                                onChange={(e) => this.handleDateOnChange(e, 'collectionDate')}
                                            />
                                        </div>
                                        <div className="row">
                                            <div className={"d-block d-md-none pl-3"}>
                                                <DatePicker
                                                    placeholderText="--/--/---- --:-- --"
                                                    minDate={new Date('01-01-1000')}
                                                    maxDate={new Date('12-31-9999')}
                                                    showTimeSelect
                                                    selected={this.state.collectionDate ? Date.parse(moment(this.state.collectionDate, 'MM-DD-YYYY h:mm aa').toISOString()) : null}
                                                    dateFormat="MM/dd/yyyy h:mm aa"
                                                    onChange={(e) => this.handleDateOnChange(e, 'collectionDate')}
                                                />

                                            </div>
                                        </div>
                                    </div>


                                    <div className="form-group row">
                                        <div className={"col-12 col-md-4 pl-3 pl-md-3"}>
                                            <label htmlFor={'Date Test Ordered'} style={{fontWeight: 'bold', paddingTop: '0.5em'}}>Date Test Ordered</label>
                                        </div>
                                        <div className={"d-none d-md-block col-md-8 pl-md-0"} id={'Date Test Ordered'}>
                                            <DatePicker
                                                placeholderText="--/--/---- --:-- --"
                                                minDate={new Date('01-01-1000')}
                                                maxDate={new Date('12-31-9999')}
                                                showTimeSelect
                                                selected={this.state.testOrderedDate ? Date.parse(moment(this.state.testOrderedDate, 'MM-DD-YYYY h:mm aa').toISOString()) : null}
                                                dateFormat="MM/dd/yyyy h:mm aa"
                                                onChange={(e) => this.handleDateOnChange(e, 'testOrderedDate')}
                                            />
                                        </div>
                                        <div className="row">
                                            <div className={"d-block d-md-none pl-3"}>
                                                <DatePicker
                                                    placeholderText="--/--/---- --:-- --"
                                                    minDate={new Date('01-01-1000')}
                                                    maxDate={new Date('12-31-9999')}
                                                    showTimeSelect
                                                    selected={this.state.testOrderedDate ? Date.parse(moment(this.state.testOrderedDate, 'MM-DD-YYYY h:mm aa').toISOString()) : null}
                                                    dateFormat="MM/dd/yyyy h:mm aa"
                                                    onChange={(e) => this.handleDateOnChange(e, 'testOrderedDate')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* important information section */}
                            {this.state.facilityID && this.state.selectedServices.length > 0 && (
                                <div className="mb-2">
                                    <div className="card mt-2">
                                    <div className="card-header verlag-bold">
                                        <div className="row">
                                            <div className="col-10">
                                                <h4>
                                                    Important Information
                                                </h4>
                                            </div>
                                            <div className="col-2">
                                                {this.state.savedImportantInformation ? (
                                                <>
                                                {/* <span className="float-right pl-2">
                                                    <BsCheckCircle color={"#1E6111"} size={37} />
                                                </span> */}
                                                <button
                                                    className={"btn btn-success verlag-bold"}
                                                    style={{ float: "right" }}
                                                    onClick={() =>
                                                    showModalNoOutsideClick(
                                                        ImportantInformationModal.ID
                                                    )
                                                    }
                                                >
                                                    Review
                                                </button>
                                                </>
                                            ) : (
                                                <button
                                                className={"btn btn-primary verlag-bold"}
                                                style={{ float: "right" }}
                                                onClick={() =>
                                                    showModalNoOutsideClick(
                                                    ImportantInformationModal.ID
                                                    )
                                                }
                                                >
                                                Start
                                                </button>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}


                            {/* patient information */}
                            {this.state.facilityID && this.state.selectedServices.length > 0 && (
                            <div className="mb-2">
                                <div className="card mt-2">
                                    <div className="card-header verlag-bold">
                                    <div className="row">
                                            <div className="col-10">
                                                <h4>
                                                    Patient Information
                                                </h4>
                                            </div>
                                            <div className="col-2">
                                            {this.state.savedPatientInformation ? (
                                            <>
                                                {/* <span className="float-right pl-2">
                                                    <BsCheckCircle color={'#1E6111'} size={37}  />
                                                </span> */}
                                                <button className={"btn btn-success verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => showModalNoOutsideClick(PatientInfoModal.ID)}>
                                                    Review
                                                </button>
                                            </>
                                            )
                                            :
                                            (
                                            <button className={"btn btn-primary verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => showModalNoOutsideClick(PatientInfoModal.ID)}>
                                                Start
                                            </button>
                                            )
                                        }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}

                            {/* insurance information  */}
                            {this.state.facilityID && this.state.showInsurance && (
                            <div className={"mt-2"}>
                                <div className="card mt-2">
                                    <div className="card-header verlag-bold">
                                    <div className="row">
                                            <div className="col-10">
                                                <h4>
                                                    Insurance Information
                                                </h4>
                                            </div>
                                            <div className="col-2">
                                            {this.state.savedInsuranceInformation ? (
                                            <>
                                                {/* <span className="float-right pl-2">
                                                    <BsCheckCircle color={'#1E6111'} size={37}  />
                                                </span> */}
                                                <button className={"btn btn-success verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => showModalNoOutsideClick(InsuranceModal.ID)}>
                                                    Review
                                                </button>
                                            </>
                                            )
                                            :
                                            (
                                            <button className={"btn btn-primary verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => showModalNoOutsideClick(InsuranceModal.ID)}>
                                                Start
                                            </button>
                                            )
                                        }
                                            </div>
                                        </div>
                                 
                                    </div>
                                </div>
                            </div>
                            )}

                            {/* service information  */}
                            {this.state.facilityID && this.state.selectedServices?.length > 0 && this.state.selectedServices.map(ss => (
                                <div className="card mt-2">
                                    <div className="card-header verlag-bold">
                                        <div className="row">
                                            <div className="col-10">
                                                <h4>{getNameFromID(ss.ID, this.state.services)}</h4>
                                            </div>
                                            <div className="col-2">
                                            {this.state.savedServices && this.state.savedServices.includes(ss.ID) ?
                                            <>
                                                {/* <span className="float-right pl-2">
                                                    <BsCheckCircle color={'#1E6111'} size={37}  />
                                                </span> */}
                                                <button className={"btn btn-success verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => {this.setState({selectedServiceID: ss.ID, serviceSpecificCustomQuestions: this.state.allCustomQuestions.filter(f => f.ServiceID === ss.ID && f.Options.isActive)}, () =>   showModalNoOutsideClick(ServiceFormModal.ID))}}>
                                                    Review
                                                </button>
                                            </>
                                            :
                                            <button className={"btn btn-primary verlag-bold"}
                                                style={{float: 'right'}}
                                                onClick={() => {this.setState({selectedServiceID: ss.ID, serviceSpecificCustomQuestions: this.state.allCustomQuestions.filter(f => f.ServiceID === ss.ID && f.Options.isActive)}, () =>   showModalNoOutsideClick(ServiceFormModal.ID))}}>
                                                Start
                                            </button>
                                            }
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )) 
                        }

                        {/* ROI section */}
                        {this.state.facilityID && this.state.selectedServices?.length > 0 && (
                            <div className="mb-2">
                                <div className="card mt-2">
                                <div className="card-header verlag-bold">
                                <div className="row">
                                            <div className="col-10">
                                                <h4>
                                                    Release of Information
                                                </h4>
                                            </div>
                                            <div className="col-2">
                                                {this.state.savedROIServices.length > 0 || this.state.declineConsent ? (
                                                <>
                                                    {/* <span className="float-right pl-2">
                                                        <BsCheckCircle color={"#1E6111"} size={37} />
                                                    </span> */}
                                                    <button
                                                        className={"btn btn-success verlag-bold"}
                                                        style={{ float: "right" }}
                                                        onClick={() =>
                                                        showModalNoOutsideClick(
                                                            ROIModal.ID
                                                        )
                                                        }
                                                    >
                                                        Review
                                                    </button>
                                                    </>
                                                ) : (
                                                    <button
                                                    className={"btn btn-primary verlag-bold"}
                                                    style={{ float: "right" }}
                                                    onClick={() =>
                                                        showModalNoOutsideClick(
                                                        ROIModal.ID
                                                        )
                                                    }
                                                    >
                                                    Start
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}


                        {this.state.facilityID && this.state.selectedServices.length > 0 && (
                            <div className="card mb-2  mt-2">
                                <div className="card-header verlag-bold">
                                    <h4>Summary</h4>
                                </div>
                                <div className="card-body">
                                <div className="row mt-3" id={'infcon'}>
                                    <h4 className="col-12">
                                        <a href="#infcon" className="text-primary" onClick={() => showModalNoOutsideClick(InformedConsentModal.ID) }>Informed Consent</a>
                                    </h4>
                                </div>
                                    <br/>
                                    {this.state.selectedServices.map(ss => (
                                        <div className={"p-2 mb-2"} style={{borderWidth: '1px', borderColor: 'lightgray', borderStyle: 'solid', borderRadius: 15}}>
                                            <h5 className="text-center pb-2">
                                                <span >{ss.Name}</span>
                                               
                                            </h5>
                                            <div>{Parser(ss.Summary)}</div>
                                        </div>
                                    ))}
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="acknowledge"
                                           value={this.state.acknowledged}
                                           onChange={(e) => this.setState({acknowledged: e.target.checked})}/>
                                    <label className="form-check-label" htmlFor="acknowledge">
                                        I acknowledge and agree that I have read, understand, and agreed to the
                                        statements contained within this form.
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}
                                            
                                        
                                        

                            {/* footer  */}
                            {this.state.facilityID && this.state.selectedServices.length > 0 && 
                            <div className={"pr-3 mt-2 pl-3 "} style={{ height: '3.5em', border: '1px solid lightgrey', borderRadius: 5, backgroundColor: '#F7F7F7'}}>
                                <button className={"btn immyClearButtonOutline float-right my-2"}  onClick={() => {
                                    this.clear();
                                }} disabled={this.state.isSubmitting}>Clear</button>
                                <button className={"btn immySubmitButtonOutline float-left my-2"}  onClick={() => {
                                    this.submit();
                                }} disabled={this.state.isSubmitting}>Submit</button>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}